import React, { createContext, useMemo, useRef } from 'react'
import PropTypes from 'prop-types'
import './styles.scss'
import useTimeline from './customHooks/useTimeline'
import TimelineControls from './TimelineControls'
import { useWindowSize } from '@uidotdev/usehooks'
import TimelineContent from './TimelineContent'
import { InViewSimpleTransition } from '../../shared/utils/animations/transitions'
import moment from 'moment'
import MobileTimelineControls from './MobileTimelineControls'

export const TimelineContext = createContext()

Timeline.propTypes = {
  data: PropTypes.object,
}

export default function Timeline({ data }) {
  // console.log(data)

  const hasValidEvents = Array.isArray(data?.story_events) && [...data.story_events].length > 0
  const story_events = hasValidEvents ? data?.story_events : []
  const dataOrdered = [...story_events].map((item, index) => ({
    ...item,
    date: moment(item.event_date).toISOString(),
    id: index + 1,
    year: moment(item?.event_date).year(),
    page: `${Number(index + 1)
      .toString()
      .padStart(2, '0')}/${story_events.length}`,
  }))
  const ref = useRef()
  const { width } = useWindowSize()
  const { timelineCurrentEvent, selectEvent, timeLineEvents, next, previous, timelineControls } =
    useTimeline(dataOrdered)

  // console.log(`${timelineCurrentEvent.event.id} === ${dataOrdered[0]?.event?.id}`);
  const isFirst = useMemo(
    () => timelineCurrentEvent.event.id === (dataOrdered[0]?.id ?? 1),
    [timelineCurrentEvent],
  )
  const isLast = useMemo(
    () => timelineCurrentEvent.event.id === dataOrdered[dataOrdered.length - 1]?.id,
    [timelineCurrentEvent],
  )

  return (
    <section ref={ref} className="TimelineModule">
      <InViewSimpleTransition type="fade" parent={ref} className="main-module-container">
        <div className="title-section">
          <h2>Our Story</h2>
        </div>
        <hr />
        {width <= 1020 ? (
          <MobileTimelineControls
            options={timeLineEvents}
            setSelectedOption={selectEvent}
            selectedOption={timelineCurrentEvent.event}
          />
        ) : null}
        <TimelineContent
          content={timelineCurrentEvent}
          isFirst={isFirst}
          isLast={isLast}
          next={next}
          previous={previous}
          controls={timelineControls}
          externalWidth={width}
        />
      </InViewSimpleTransition>
      {width > 1021 ? (
        <InViewSimpleTransition type="slide" className="timeline-footer">
          <ol className="timeline-controls">
            <TimelineControls
              events={timeLineEvents}
              eventAction={selectEvent}
              current={timelineCurrentEvent.event.id}
            />
          </ol>
        </InViewSimpleTransition>
      ) : null}
    </section>
  )
}
